/* Shared transcript bubble used in live chat and history review views. */
import React from "react";
import MessageContent from "./MessageContent";

function ChatMessage({ role, content, label, footer = null }) {
  // The UI only distinguishes between student and assistant bubbles.
  const normalizedRole = role === "assistant" ? "assistant" : "user";
  const resolvedLabel = label || (normalizedRole === "assistant" ? "AI Tutor" : "You");

  return (
    <div className={`message-row ${normalizedRole}`}>
      <div className={`message-bubble ${normalizedRole}`}>
        <div className="message-label">{resolvedLabel}</div>
        <div className="message-content">
          <MessageContent content={content} />
        </div>
        {footer}
      </div>
    </div>
  );
}

export default ChatMessage;
